import { axiosGet } from "../../react_axios/Axios";
import { GET_NOTIFICATION_LIST_ACTION_TYPE, getNotificationUrl, READ_NOTIFICATION_ACTION_TYPE, readNotificationUrl, getNotificationPreviewUrl, headers } from "../../utils/constants";

export const getNotification_action = () => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const roleID = sessionStorage.getItem('RoleIDSS');
        const recipientID = roleID == 1 ? sessionStorage.getItem('ExhRegistrationIDSS') :
            roleID == 3 ? sessionStorage.getItem('currentVisitorID') :
                sessionStorage.getItem('AccountIDSS');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RecipientID: recipientID,
            RoleName: loginData.RoleName,
        };
        const res = await axiosGet(getNotificationUrl, params, headers);
        dispatch({
            type: GET_NOTIFICATION_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getNotificationPreview_action = (feaIntimationRecipientID) => async () => {
    try {
        const res = await axiosGet(getNotificationPreviewUrl, {
            FeaIntimationRecipientID: feaIntimationRecipientID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const readNotification_action = (IntimationNotificationID) => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            IntimationNotificationID:IntimationNotificationID
        };
        const res = await axiosGet(readNotificationUrl, params, headers);
        dispatch({
            type: READ_NOTIFICATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
